import MobileMenuItemsMock from "@/src/__mocks__/api/MobileMenuItemsMock"
import { Link } from "@/src/common/components/Link"
import { useAnalytics } from "@/src/sb/components/Analytics"
import { Account } from "@/src/sb/components/Navigationbar/MobileNavbar/MobileNavbar"
import { useUser } from "@/src/sb/hooks/useUser"

type PlatformisationMobileNavbarProps = {
  setNextQueryParam?: boolean
  onClickIntelligence?: (itemsIDToHide: Array<number>) => void
}

const PlatformisationMobileNavbar = ({
  setNextQueryParam,
  onClickIntelligence
}: PlatformisationMobileNavbarProps) => {
  const analytics = useAnalytics()
  const user = useUser()

  const mobileMenuItemsIDs = MobileMenuItemsMock().map(
    (menuItem) => menuItem.id
  )

  return (
    <section
      className={
        "flex justify-between dark:bg-black dark:text-stears_white fixed bottom-0 left-0 z-10 w-full p-2.5 md:hidden leading-[18px]"
      }
    >
      {MobileMenuItemsMock().map((sideBarMenuItem) => {
        const item = (
          <>
            <span
              className={"inline-block shrink-0 dark:text-white"}
              dangerouslySetInnerHTML={{
                __html: sideBarMenuItem.icon ?? ""
              }}
            />{" "}
            {sideBarMenuItem.label}
          </>
        )
        const itemProps = {
          className:
            "flex flex-col gap-0.5 items-center justify-between cursor-pointer dark:text-gray-400 text-xs font-jakarta w-[52px]"
        }

        return sideBarMenuItem.label === "Reports" ||
          sideBarMenuItem.label === "Data" ||
          sideBarMenuItem.label === "Countries" ? (
          <section
            key={sideBarMenuItem.id + sideBarMenuItem.label}
            {...itemProps}
            onClick={() =>
              onClickIntelligence?.(
                mobileMenuItemsIDs.filter((id) => id !== sideBarMenuItem.id)
              )
            }
          >
            {item}
          </section>
        ) : (
          <Link
            key={sideBarMenuItem.id + sideBarMenuItem.label}
            {...itemProps}
            href={sideBarMenuItem.destination}
          >
            {item}
          </Link>
        )
      })}

      <Account
        userType={user.userType}
        onClick={(label: string) => analytics?.clickNavItem(label)}
        setNextQueryParam={setNextQueryParam}
      />
    </section>
  )
}

export default PlatformisationMobileNavbar
